export default __webpack_public_path__ + "static/media/piper.5674cad2.png";